import { apiClient } from '@/services/ApiClient.js'

export class KeysfinReportService {
  async getApplicationsReadyKeysfinReports(applicationId, keysfinRequestId) {
    return apiClient.get(`applications/${applicationId}/keysfin-requests/${keysfinRequestId}/report`)
  }

  async getApplicationsReadyKeysfinAMLReports(applicationId) {
    return apiClient.get(`applications/${applicationId}/keysfin-aml-reports`)
  }
}
